import { createStoreon } from 'storeon';
import { storeonDevtools } from 'storeon/devtools';
import {
  globalState,
  modelJson,
  suggestions,
  sponsoredBrands,
  cookies,
  auth,
  productRedirectionUrl,
  headerDrawers,
  sponsoredProducts,
  loyaltyReducer,
  loyaltyRegistrationModalReducer,
} from '../reducers';
import { State, Events } from './types';
import { b2bOrganizationReducer } from 'reducers/b2b-organization';

export const createStore = () =>
  createStoreon<State, Events>([
    ...modelJson,
    ...globalState,
    suggestions,
    sponsoredBrands,
    cookies,
    auth,
    productRedirectionUrl,
    headerDrawers,
    sponsoredProducts,
    loyaltyReducer,
    loyaltyRegistrationModalReducer,
    b2bOrganizationReducer,
    !__IS_SERVER__ && process.env.NODE_ENV !== 'production' && storeonDevtools,
  ]);
